import React from 'react';
import { MapPin, Phone, Clock, ChevronUp, ShoppingBag } from 'lucide-react';
import { LINKS } from '../config/links';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl font-bold text-amber-500 mb-4">Le Paradis</h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Pizzeria artisanale au cœur de Bondy. Savourez nos pizzas,
              burgers et plats méditerranéens préparés avec passion.
            </p>
            <a
              href={LINKS.uberEats}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-amber-500 hover:text-amber-400 transition-colors font-medium"
            >
              <ShoppingBag className="w-5 h-5" />
              Commander sur Uber Eats
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Navigation</h4>
            <ul className="space-y-3">
              {[
                { href: '#accueil', label: 'Accueil' },
                { href: '#menu', label: 'Menu' },
                { href: '#apropos', label: 'À propos' },
                { href: '#galerie', label: 'Galerie' },
                { href: '#commander', label: 'Commander' },
                { href: '#contact', label: 'Contact' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-gray-400 hover:text-amber-500 transition-colors duration-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-4">
              {LINKS.phone && (
                <li>
                  <a
                    href={`tel:${LINKS.phone}`}
                    className="flex items-center gap-3 text-gray-400 hover:text-amber-500 transition-colors duration-300"
                  >
                    <Phone className="w-5 h-5 text-amber-500" />
                    {LINKS.phoneDisplay}
                  </a>
                </li>
              )}
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <span>
                  43 Av. du Maréchal de Lattre de Tassigny<br />
                  93140 Bondy, France
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Clock className="w-5 h-5 text-amber-500" />
                Ouvert jusqu'à 23:30
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-semibold text-white mb-4">Horaires</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex justify-between">
                <span>Lundi - Dimanche</span>
                <span>11:00 - 23:30</span>
              </li>
            </ul>
            <div className="mt-6 p-4 bg-amber-600/10 rounded-xl border border-amber-600/20">
              <p className="text-amber-500 text-sm font-medium">
                Offre 3 pizzas à 19,99€ (à emporter)
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} Le Paradis – Bondy. Tous droits réservés.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-gray-500 hover:text-amber-500 text-sm transition-colors">
                Mentions légales
              </a>
              <a href="#" className="text-gray-500 hover:text-amber-500 text-sm transition-colors">
                Politique de confidentialité
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-24 right-6 w-12 h-12 bg-amber-600 hover:bg-amber-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:-translate-y-1 z-40"
        aria-label="Retour en haut"
      >
        <ChevronUp className="w-6 h-6" />
      </button>
    </footer>
  );
};

export default Footer;
